<template>
  <span class="kl" :class="{ split, one: oneLine }">
    <span v-for="(ln, li) in lines" :key="li" class="kl-ln" :class="li ? 'kl-skills' : 'kl-gear'">
      <span v-for="p in ln" :key="p.dim + p.v" class="kl-p" :style="wrStyleFor(unit, p.dim, p.v)" v-tip="wrTipFor(unit, p.dim, p.v)">{{ p.v }}</span>
    </span>
  </span>
</template>

<script>
// A unit's kit as a line of names: its gear, then its skillset / reaction / support / move, each colored by win rate
// when the switch is on (lib/wrPref.js), with the gap to the average on hover. `split` puts the two groups on their
// own lines (the team rows); otherwise they run on, a bar between them. `oneLine` keeps it to one line, cut with "…"
// (the spotlight's unit cards, where the space goes to the damage line under it).
import { kitPieces, wrStyleFor, wrTipFor } from '../../lib/wrPref.js';

export default {
  name: 'KitLine',
  props: { unit: { type: Object, required: true }, split: { type: Boolean, default: false }, oneLine: { type: Boolean, default: false } },
  computed: { lines() { return kitPieces(this.unit); } },
  methods: { wrStyleFor, wrTipFor },
};
</script>

<style scoped>
.kl { display: flex; flex-wrap: wrap; gap: 0 4px; }
.kl.split { flex-direction: column; flex-wrap: nowrap; gap: 1px; }
.kl-ln { display: flex; flex-wrap: wrap; gap: 0 4px; }
.kl:not(.split) .kl-ln + .kl-ln::before { content: '|'; color: var(--mute); opacity: .6; margin-right: 2px; }
.kl-p:not(:last-child)::after { content: ' ·'; color: var(--mute); }
.kl.split .kl-skills { color: var(--mute); }
.kl.one { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.kl.one .kl-ln { display: inline; }
.kl.one .kl-ln + .kl-ln::before { margin: 0 4px 0 6px; }
.kl.one .kl-p:not(:last-child)::after { margin-right: 4px; }
</style>
